exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5327dd72] .vue-treeselect__control,[data-v-5327dd72] .vue-treeselect__placeholder,[data-v-5327dd72] .vue-treeselect__single-value{height:30px;line-height:30px}", ""]);

// exports
